export default () => Math.random() * 100;



// WEBPACK FOOTER //
// ./src/helpers/random.ts